import React, {Fragment, PureComponent} from 'react';
import {connect} from "react-redux";
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

import CallToActions from '../CallToActions/CallToActions.jsx';

import {generate} from '../../routes.js';

import screen from './images/screen.png';

import './AskForReinforcement.scss';

const catchPhrases = {
  purchase: <Fragment>
    Accédez aux meilleurs spécialistes indépendants <strong>des Achats, Supply Chain et Juridique</strong>.
  </Fragment>,
  hr: <Fragment>
    Accédez aux meilleurs spécialistes indépendants dans les <strong>Ressources Humaines</strong>.
  </Fragment>,
  finance: <Fragment>
    Accédez aux meilleurs spécialistes indépendants du secteur de la <strong>Finance</strong>.
  </Fragment>,
  engineering: <Fragment>
    Accédez aux meilleurs spécialistes indépendants du secteur de l'<strong>ingénierie</strong>.
  </Fragment>
};

class AskReinforcement extends PureComponent {
  static propTypes = {
    universeCode: PropTypes.string,
  }

  render() {
    return (
      <section className="container py-5 ask-for-reinforcement">
        <div className="row">
          <div className="col-md-6">
            <h2>Demandez vos renforts en quelques clics</h2>
            <p>
              { catchPhrases?.[this.props.universeCode] ?? (
                <Fragment>
                  Accédez aux meilleurs spécialistes indépendants <strong>des Achats, Finance, Ingénierie & Ressources Humaines</strong>
                </Fragment>
              ) }
            </p>
            <CallToActions className="justify-content-lg-start">
              <Link className="btn btn-primary" to={generate({name: 'drop-need'})}>Proposer une mission</Link>
              {!this.props.isConnected ?
                <Link className="btn btn-outline-secondary" to={generate({name: 'register-do'})}>
                  Inscrire votre établissement
                </Link> : ''
              }
            </CallToActions>
          </div>
          <div className="col-md-6 text-center">
            <img alt="Exemple de la page déposer un besoin sur notre plateforme" className="w-75" src={screen.src}/>
          </div>
        </div>
      </section>
    );
  }
}

export default connect(
  (state) => ({
    isConnected: Boolean(state.currentUser?.user?.id),
  })
)(AskReinforcement);
